export const ThemeType = {
  Default: 'default',
  Dark: 'defaultDark',
};
